import React from 'react';
import styled from '@emotion/styled';
import { Paper, Shimmer, ShimmerPlaceholderText } from '../../../../../ui';
import themed from '../../../../../ui/themer/themed';

export const ExtrasShimmer = () => (
	<Paper>
		<Shimmer data-testid="extras-shimmer">
			<ShimmerPlaceholderText height="1.75em" />
			<List>
				<li>
					<ShimmerPlaceholderText />
				</li>
				<li>
					<ShimmerPlaceholderText />
				</li>
				<li>
					<ShimmerPlaceholderText />
				</li>
			</List>
		</Shimmer>
	</Paper>
);

const List = styled.ul`
	color: ${themed(({ shimmer }) => shimmer.placeholder.background)};
`;
